import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs/Observable";
import { SharedService } from "./../shared/shared.service";
import { PrasadOrderView } from "./prasad-order";
import { PujaPrasadMaster } from "./puja-prasad-master";
import { PayUMoneyPayment } from "./pay-u-money-payment";
import { PujaPrasadOrderResponse } from './puja-prasad-order-response';
import { PujaPrasadOrder } from './puja-prasad-order';

@Injectable()
export class PujaPrasadOrderService {

  constructor(private _http: HttpClient) { }

  ServiceUrl: string = SharedService.BaseServiceUrl + "PrasadOrders";


  public getByMobileNo(mobileNo: string): Observable<PrasadOrderView[]> {
    let getbyMobileUrl = this.ServiceUrl + "/GetByMobileNo/" + mobileNo;
    return this._http.get<PrasadOrderView[]>(getbyMobileUrl);
  }

  public getDevoteeOrders(): Observable<any> {
    var url= SharedService.BaseServiceUrl + "my/orders";
    return this._http.get<any>(url);
  }

  public save(pujPrasadOrder: PujaPrasadOrder) : Observable<PujaPrasadOrderResponse> {
    var url= SharedService.BaseServiceUrl + "book/puja/vidhis";
    return this._http.post<PujaPrasadOrderResponse>(url, pujPrasadOrder);
  }

  public paymentRetry(paymentRetryRequest: any) : Observable<PujaPrasadOrderResponse> {
    var url= SharedService.BaseServiceUrl + "book/puja/vidhis/payment/retry";
    return this._http.post<PujaPrasadOrderResponse>(url, paymentRetryRequest);
  }


  public getPayUMoneyPayment(payUMoneyPayment: PayUMoneyPayment): Observable<PayUMoneyPayment> {
    let getbyMobileUrl = SharedService.BaseServiceUrl + "PayUMoney/RequestPost";
    //let paramData = new HttpParams().set("prasadId", prasadId.toString()).set("mobileNo", mobileNo.toString());

    return this._http.post<PayUMoneyPayment>(getbyMobileUrl, payUMoneyPayment);
  }

  public getPayUMoneyPaymentByTransId(transId: string): Observable<PayUMoneyPayment> {
    let getbyMobileUrl = SharedService.BaseServiceUrl + "PayUMoney/GetbyTransId/" + transId;

    return this._http.get<PayUMoneyPayment>(getbyMobileUrl);
  }



}



// WEBPACK FOOTER //
// ./src/app/prasad-order/puja-prasad-order.service.ts